module.exports = "/desktop-app/assets/img/empty.png?367177c68bcabd96341fd057a5db4e69";


//////////////////
// WEBPACK FOOTER
// ./foody/src/assets/common/static/icons/empty.png
// module id = A3DY
// module chunks = 1